import { identity } from 'ramda';
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../Button';

const FormButtons = (props) => {
  const {
    submitDisabled = false,
    onSubmit = () => void 0,
    onCancel,
    submitLabel,
    cancelLabel = 'Cancel',
    isBusy = false,
    extraButtonProps = {},
    wrapperClassNames = [],
  } = props;
  return (
    <div className={["lsn-form-buttons", ...wrapperClassNames].filter(identity).join(' ')}>
      {submitLabel ? <div className="text-center">
        <Button
          text={submitLabel}
          classNames={['mTop-45 mYSm-10']}
          onClick={onSubmit}
          disabled={submitDisabled}
          {...extraButtonProps}
          isNew
          busy={isBusy}
          size="large"
        />
      </div> : void 0 }
      { onCancel ? <div className="text-center">
        <Link to={onCancel} className="ref-blue-text" label={cancelLabel} rel="noopener noreferrer">
          {cancelLabel}
        </Link>
      </div> : void 0 }
    </div>
  );
};

export default FormButtons;
